import { PropertiesStore } from './propertiesStore';
import { PropertyFormStore } from './propertyFormStore';

const propertyInformationForm = {
  fields: {
    address: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The address is required.',
    },
    __isAddressInCorrectFormat__: {
      value: true,
      error: null,
      rule: 'accepted',
      message: 'Invalid Address Format.',
    },
    streetNumber: {
      value: '',
      error: null,
      rule: '',
    },
    streetName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The Street Name is required.',
    },
    city: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The City is required.',
    },
    state: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The State is required.',
    },
    county: {
      value: '',
      error: null,
      rule: '',
    },
    zipCode: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The Zip Code is required.',
    },
    latitude: {
      value: 0,
      error: null,
      rule: '',
    },
    longitude: {
      value: 0,
      error: null,
      rule: '',
    },
    aptNumber: {
      value: '',
      error: null,
      rule: '',
    },
    propertyType: {
      value: '',
      error: null,
      rule: 'required',
    },
    units: {
      value: '',
    },
    propertyValuation: {
      value: '',
      error: null,
      rule: 'required',
    },
    purchasePrice: {
      value: '',
      error: null,
      rule: 'required',
    },
    isAppraisalAvailable: { value: false },
    isPreflight: { value: false },
  },
  meta: {
    key: null,
    editMode: false,
    isValid: false,
    error: null,
  },
};

export class RentalPortfolioPropertiesStore extends PropertiesStore {
  constructor(globalStore, loanSubType) {
    super(globalStore, loanSubType);
  }

  reset() {
    this.propertyFormStores = [];
  }

  createPropertyForm() {
    return new PropertyFormStore(propertyInformationForm, this.globalStore, this.loanSubType);
  }

  getProperties() {
    return this.propertyFormStores.map(form => {
      const property = form.getFormValues();
      return {
        ...property,
        nsfrLoanPropertyFields: {
          acquisitionPrice: property.purchasePrice,
          propertyValuation: property.propertyValuation,
        }
      };
    });
  }

  addNewPropertyWithPropertyType(propertyType: string): void {
    const initialForm = { ...propertyInformationForm };
    initialForm.fields.propertyType.value = propertyType;
    const newForm = new PropertyFormStore(initialForm, this.globalStore, this.loanSubType);
    this.propertyFormStores.push(newForm);
  }
}
